import * as actions from '../actions';

var defaultState = null;

export default function accounts(state = defaultState, action) {
    switch (action.type) {

        case actions.ACCOUNT_GET:
        case actions.ACCOUNT_GET_NAMEANDIDS:
            var newState = state;
            if (!action.error) {
                newState = action.payload.data;
            }
            return newState;

        case actions.ACCOUNT_CLEAN:
            return defaultState;

        default:
            return state;

    }
}
